var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlogNotes = function SvgBlogNotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 196,
    height: 237,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#blogNotes_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA00",
    d: "M166.947 85.274 46.502 40.71 1.849 161.398l120.445 44.563z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7200CC",
    d: "m165.09 86.123-43.653 117.985-117.74-43.562L47.35 42.561zm3.697-1.705L45.653 38.86 0 162.25l123.134 45.558z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0BB05",
    d: "M164.994 85.524 47.614 42.095 38.642 66.35l117.379 43.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA00",
    d: "m144.026 33.034-82.61 98.64 98.371 82.607 82.61-98.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7200CC",
    d: "m144.212 35.08 96.156 80.759-80.763 96.419-96.156-80.76zm-.348-4.063-1.848 2.205-80.763 96.419-1.848 2.205 2.199 1.848 96.157 80.76 2.198 1.848 1.849-2.205 80.762-96.419 1.848-2.205-2.198-1.848-96.157-80.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0BB05",
    d: "m240.492 115.297-95.867-80.504-16.601 19.822 95.867 80.504z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "blogNotes_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m60.03 0 199.766 73.91-60.03 162.251L0 162.251z"
  })))));
};
export { SvgBlogNotes as ReactComponent };
export default "/_next/static/media/src/components/Blog/assets/blogNotes.4041ff84dd66abae8f4aa9739b23f000.svg";